import { useBrandContext } from '../../context/BrandContext';
import evIcon from '../../assets/ev-icon.png';
import checkIcon from '../../assets/check-icon-3d.png';
import { useVehicleStore } from '../../hooks/useVehicleStore';

export const AutoChargeAccept = ({ vehicles }: { vehicles: any[] }) => {
  const brandContext = useBrandContext();
  const { selectedVehicle, setSelectedVehicle } = useVehicleStore();

  const handleVehicleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedVehicle(e.target.value);
  };

  return (
    <>
      <div
        className='modal-pattern-header-title'
        tabIndex={0}
        style={{ width: '100%', textAlign: 'left', fontSize: 32 }}
      >
        Ative o{' '}
        <span style={{ color: brandContext.brandBgColor }}>AutoCharge</span>{' '}
        neste veículo
      </div>
      <img
        src={evIcon}
        alt='EV Icon'
        width='90%'
        style={{ display: 'block', margin: 'auto' }}
      />
      <div style={{ fontSize: 14 }}>Veículo</div>
      {(vehicles?.length || 0) > 1 && (
        <div className='select__container select__container--brand'>
          <select
            id='select-uvId'
            className='select__input'
            value={selectedVehicle}
            onChange={handleVehicleChange}
          >
            {vehicles?.map((vehicle) => (
              <option key={vehicle.uvId} value={vehicle.uvId}>
                {vehicle.uvName}
              </option>
            ))}
          </select>
        </div>
      )}
      <div style={{ fontSize: 14, padding: '10px 0' }}>
        Com o AutoCharge, você não precisa mais abrir o app para iniciar uma
        recarga. Basta conectar o cabo e a sessão começa automaticamente, com
        toda a segurança e praticidade.
      </div>
      <div style={{ fontSize: 14, padding: '10px 0', marginBottom: 10 }}>
        Ative agora esta nova forma de iniciar recargas da{' '}
        {brandContext.brandData.appDisplayName}!
      </div>
    </>
  );
};

export const AutoChargeConfirmed = () => {
  const brandContext = useBrandContext();
  return (
    <>
      <div style={{ display: 'flex' }}>
        <div
          className='modal-pattern-header-title'
          tabIndex={0}
          style={{ width: '65%', textAlign: 'left', fontSize: 32 }}
        >
          <span style={{ color: brandContext.brandBgColor }}>AutoCharge</span>{' '}
          ativado!
        </div>
        <img
          src={checkIcon}
          alt='Check'
          width='35%'
          style={{ display: 'block', margin: 'auto' }}
        />
      </div>
      <img
        src={evIcon}
        alt='EV Icon'
        width='100%'
        style={{ display: 'block', margin: 'auto' }}
      />
      <div style={{ fontSize: 14, padding: '10px 0', marginBottom: 10 }}>
        Em suas próximas recargas, basta conectar o cabo e a sessão começa
        automaticamente, com toda a segurança e praticidade.
      </div>
    </>
  );
};
